@charset "UTF-8";

/* src/app/reports/report-viewer/report-viewer.component.scss */
.report-component .loading-indicator {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 300px;
  font-size: 20px;
  color: #666;
  gap: 12px;
}
.report-component .line-connector {
  border-top: 2px solid #006f8a;
  margin: 10px 0;
}
.report-component .action-bar {
  display: flex;
  justify-content: space-between;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.report-component .action-bar.right {
  flex: 1;
  justify-content: flex-end;
}
.report-component .action-bar.right .action-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  margin-top: -30px;
  margin-right: 10px;
}
.report-component .report-window {
  padding-right: 10px;
  min-height: 300px;
}
.report-component .loader-host {
  position: relative;
  min-height: 300px;
}
.report-component .loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2;
}
.report-component .loading-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  color: #444;
}
.report-component .report-container.dimmed {
  filter: blur(1px);
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
report-container.rpt-turnover-checklist {
}
report-container.rpt-turnover-checklist,
report-container.rpt-turnover-checklist * {
  box-sizing: border-box;
}
report-container.rpt-turnover-checklist table,
report-container.rpt-turnover-checklist thead,
report-container.rpt-turnover-checklist tbody,
report-container.rpt-turnover-checklist tr,
report-container.rpt-turnover-checklist th,
report-container.rpt-turnover-checklist td {
  all: revert;
  font: inherit;
  color: inherit;
}
report-container.rpt-turnover-checklist table.checklist {
  width: 100%;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  border: 1px solid #c2d2e5;
  border-radius: 6px;
  overflow: hidden;
}
report-container.rpt-turnover-checklist .checklist thead th {
  text-align: left;
  color: #fff;
  background: #2e6ba7;
  padding: 9px 12px;
  font-weight: 700;
  border-right: 1px solid rgba(255, 255, 255, 0.25);
}
report-container.rpt-turnover-checklist .checklist thead th:last-child {
  border-right: none;
}
report-container.rpt-turnover-checklist .checklist tbody td {
  padding: 6px 12px;
  border-bottom: 1px dotted #d7e1ec;
}
report-container.rpt-turnover-checklist .checklist td.num {
  text-align: right;
  white-space: nowrap;
}
report-container.rpt-turnover-checklist .checklist .section td {
  font-weight: 700;
  background: #eef5ff;
  border-top: 1px solid #cbd6e2;
  border-bottom: 1px solid #cbd6e2;
  padding: 8px 12px;
}
report-container.rpt-turnover-checklist .checklist tr.hi > td {
  background: #eaf3ff;
  box-shadow: inset 0 0 0 9999px #eaf3ff;
  border-top: 1px solid #d5e3f5;
  border-bottom: 1px solid #d5e3f5;
  background-clip: padding-box;
}
report-container.rpt-turnover-checklist .lead {
  display: flex;
  align-items: center;
}
report-container.rpt-turnover-checklist .lead .label {
  flex: 0 1 auto;
}
report-container.rpt-turnover-checklist .lead .dots {
  flex: 1 1 auto;
  height: 0;
  border-bottom: 1px dotted #9db0c3;
  margin: 0 8px;
}
report-container.rpt-turnover-checklist tr.sub .lead .label {
  padding-left: 16px;
  position: relative;
}
report-container.rpt-turnover-checklist tr.sub .lead .label::before {
  content: "\2022";
  position: absolute;
  left: 0;
  top: 0;
  line-height: 1;
  opacity: 0.6;
}
report-container.rpt-turnover-checklist .checklist tbody tr.data:nth-child(even) {
  background: #fbfdff;
}
report-container.rpt-turnover-checklist .checklist tbody tr.data:hover {
  background: #f7fbff;
}
report-container.rpt-turnover-checklist td.var {
  position: relative;
}
report-container.rpt-turnover-checklist tr.v-pos td.var {
  color: #0a8a00;
  font-weight: 600;
  background:
    linear-gradient(
      to right,
      rgba(10, 138, 0, 0.07),
      transparent);
}
report-container.rpt-turnover-checklist tr.v-neg td.var {
  color: #b42318;
  font-weight: 600;
  background:
    linear-gradient(
      to right,
      rgba(180, 35, 24, 0.08),
      transparent);
}
report-container.rpt-turnover-checklist tr.v-zero td.var {
  color: #5b6b7a;
  opacity: 0.85;
}
report-container.rpt-turnover-checklist tr.v-pos td.var::before {
  content: "\25b2  ";
}
report-container.rpt-turnover-checklist tr.v-neg td.var::before {
  content: "\25bc  ";
}
/*# sourceMappingURL=report-viewer.component-EBUMFEGA.css.map */
